import type { TOC } from '@ember/component/template-only';

import BillingCompareChangesComponent from 'webapp/components/billing/compare/changes';

const SettingsBillingCompareRouteTemplate: TOC<object> = <template>
	<BillingCompareChangesComponent />
</template>;

export default SettingsBillingCompareRouteTemplate;
